import GlobalAxios from "../axios/axios-config";

const CLICK_REPASSE_AUTH_ROUTE =
  process.env.REACT_APP_APP + "/api/v1/ClickRepasse/Auth";

export const getClickRepasseAuthUrl = () => {
  return GlobalAxios.post<string>(CLICK_REPASSE_AUTH_ROUTE);
};
